import { getImageUrl } from './images'
import { IMAGE_WIDTH } from 'constants/media'

const getEventImage = (event, md) =>
  getImageUrl({
    media: md ? event.media : event.verticalMedia,
    defaultUrl: (md ? event.media?.url : event.verticalMedia?.url) || event.image,
    width: md ? IMAGE_WIDTH.DESKTOP_IMAGE_WIDTH : IMAGE_WIDTH.MOBILE_IMAGE_WIDTH,
  })

const getEventCountdown = delta => (delta ? Date.now() + delta : null)

export { getEventImage, getEventCountdown }
